import classNames from 'classnames';
import React from 'react';

import cssMessages from '../../assets/scss/Messages.scss';

interface AlertMessageProps {
    msg: string;
    type: 'secondary' | 'info' | 'success' | 'warning' | 'error';
}

const AlertMessage: React.FC<AlertMessageProps> = (props) => {
    const className = (() => {
        switch (props.type) {
            case 'secondary':
                return cssMessages.secondaryMsg;
            case 'info':
                return cssMessages.infoMsg;
            case 'success':
                return cssMessages.successMsg;
            case 'warning':
                return cssMessages.warningMsg;
            case 'error':
                return cssMessages.errorMsg;
            default:
                return cssMessages.errorMsg;
        }
    })();
    const iconClass = (() => {
        switch (props.type) {
            case 'secondary':
                return 'fa-info-circle';
            case 'info':
                return 'fa-info-circle';
            case 'success':
                return 'fa-check';
            case 'warning':
                return 'fa-warning';
            case 'error':
                return 'fa-times-circle';
            default:
                return 'fa-times-circle';
        }
    })();
    return (
        <div className={className}>
            <i className={classNames(['fa', iconClass])} style={{ marginRight: '5px' }} />
            {props.msg && <b>{props.msg}</b>}
            {props.children}
        </div>
    );
};

export default AlertMessage;
